/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useRef, useMemo, useEffect, useState } from 'react';
import { Carousel, Image } from 'app/components';
import { format } from 'date-fns';
import { HighlightsTag } from './style';


const AdvertisementComponent = ({ data }) => {
  const [sliderAutoPlay, setSliderAutoPlay] = useState(true);
  const sliderPropsConfig = () => ({
    slidesToSlide: 1,
    arrows: true,
    infinite: true,
    responsive: {
      desktop: {
        breakpoint: {
          max: 30000,
          min: 992
        },
        items: 1
      },
      tablet: {
        breakpoint: {
          max: 992,
          min: 480
        },
        items: 1
      },
      mobile: {
        breakpoint: {
          max: 480,
          min: 0
        },
        items: 1
      }
    }
  });
  const sliderRef = useRef(null);
  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  const today = new Date();
  // eslint-disable-next-line no-unused-vars
  const [slider, setSliderData] = useState([]);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false)
  const [addData, setAddData] = useState('');
  const videoEl = useRef(null);
  const currentDate = format(new Date(), 'yyyy-MM-dd');

  // const attemptPlay = () => {
  //   videoEl &&
  //     videoEl.current &&
  //     videoEl.current.play().catch(error => {
  //       console.error('Error attempting to play', error);
  //     });
  // };

  // useEffect(() => {
  //   attemptPlay();
  // }, []);

  useEffect(() => {
    if (data?.length > 0) {
      data.forEach(element => {
        const dateFrom = format(new Date(element?.showStartDate), 'dd/MM/yyyy');

        const dateTo = format(new Date(element?.showEndDate), 'dd/MM/yyyy');

        const dateCheck = format(new Date(today), 'dd/MM/yyyy');

        const d1 = dateFrom.split('/');

        const d2 = dateTo.split('/');

        const c = dateCheck.split('/');

        const from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);

        const to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);

        const check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

        if (check >= from && check <= to && slider.length === 0) {
          let imgIdx = 0;
          let videoIdx = 0;
          // eslint-disable-next-line no-unused-vars
          const ArrayD = element?.pictureVideoUpload?.map((slideD, idx) => {
            slider.push({ ...slideD, id: `${slideD?.filePath && /\.(jpg|jpeg|png)$/.test(slideD?.filePath) ? `IMAGE-${imgIdx++}` : `VIDEO-${videoIdx++}`}` });
            return null;
          });
        }
      });
    }
  }, [data]);


  const hedalChange = (a, b, c, d, e, f) => {
    let sliderList = slider?.filter((data, index) => index === (b.currentSlide - 2) ? data : "")
    let sliderIndex = sliderList[0]?.id?.slice(0, 5);
    let imag = document.getElementsByClassName('react-multi-carousel-item--active')[0]?.children[0]?.firstElementChild?.id.split('-')[0];
    setAddData(imag);
    if (sliderIndex === 'IMAGE') {
      setSliderAutoPlay(false);

      // setIsVideoLoaded(false);
    }
    else if (sliderIndex === "VIDEO") {
      // let videoShow = document.getElementById(sliderList[0]?.id);
      let videoShow = document.getElementsByClassName('react-multi-carousel-item--active')[0]?.children[0]?.firstElementChild;
      // if (videoShow && !isVideoLoaded) 
      if (videoShow) {
        setSliderAutoPlay(false);
        setIsVideoLoaded(true);
        videoShow.play();
        return videoShow.addEventListener("ended", () => {
          setSliderAutoPlay(true);
          setIsVideoLoaded(false);
          videoShow.pause()
        });
      }
    }
    //     b.clones.forEach((element, key) => {
    //       if (key === b.currentSlide) {
    //         const propD = element.props.children.props.children.ref;

    //         if (propD) {
    //           const { duration } = element.props.children.props.children.ref.current;
    //           const minus = duration - 5;

    //           const totalD = minus * 1000;

    //           setSliderAutoPlay(false);
    //           let timer =  setTimeout(() => {
    //             setSliderAutoPlay(true);
    //           }, totalD);

    //         }
    //       }
    //     });
  };

  useEffect(() => {
    // var id = videoEl.current?.id;
    // var vid = document.getElementById(id);
    var vid = document.getElementsByClassName('react-multi-carousel-item--active')[0]?.children[0]?.firstElementChild;
    let video = document.getElementsByClassName('react-multi-carousel-item--active')[0]?.children[0]?.firstElementChild?.id.split('-')[0];
    if (vid && !isVideoLoaded && video === 'VIDEO') {
      setSliderAutoPlay(false);
      setIsVideoLoaded(true);
      vid.play();
      return vid.addEventListener("ended", () => {
        vid.pause();
        setSliderAutoPlay(true); setIsVideoLoaded(false);
      });
    }
  }, [sliderAutoPlay, document.getElementsByClassName('react-multi-carousel-item--active')[0]?.children[0]?.firstElementChild])


  useEffect(() => {
    if (addData === "IMAGE") {
      setTimeout(() => {
        console.log("Set AutoPLay treu");
        setSliderAutoPlay(true);
      }, 2000)
    }
  }, [addData === "IMAGE"])


  return (
    <HighlightsTag>
      {slider?.length > 0 && (
        <Carousel
          {...sliderProps}
          refEl={sliderRef}
          infinite={true}
          className="cinema-rent__carousel giftCardSliderData"
          withCaption
          afterChange={hedalChange}
          autoPlay={sliderAutoPlay}
          autoPlaySpeed={200}
        >
          {slider?.map((item, key, index) => (

            // < a href={item?.link} key={key} style={{ cursor: "pointer" }}/>
            < span className="slide_for_advertise" key={key} >
              {item?.filePath && /\.(jpg|jpeg|png)$/.test(item?.filePath) ? (
                < a href={item?.link} key={key} style={{ cursor: item?.link !== null ? "pointer" : "" }}>
                  <Image
                    src={item?.filePath}
                    key={key}
                    className="banner-slider__image"
                    id={item?.id}
                  />
                </a>
              ) : (
                <video
                  playsInline
                  // loop
                  loop={data[0]?.pictureVideoUpload?.length === 1 ? true : false}
                  autoPlay
                  muted
                  controls={false}
                  alt="All the devices"
                  ref={videoEl}
                  className="slide_for_advertise video"
                  id={item?.id}
                  style={{ cursor: item?.link !== null ? "pointer" : "" }}
                  onClick={() => (item?.link !== null ? window.location.href = item?.link.includes('/film/') ? `${item?.link}?date=${currentDate}&location=all` : item?.link : "")}
                >
                  <source src={item?.filePath} type="video/mp4" />
                </video>
              )}
            </span>
          ))}
        </Carousel>
      )}
    </HighlightsTag>
  );
};

export default AdvertisementComponent;
